import Player from '@vimeo/player';

const init = () => {
  const vimeoWrappers = document.querySelectorAll('.js-vimeoWrapper');
  if (vimeoWrappers.length !== 0) {

  vimeoWrappers.forEach((vimeoWrapper) => {
    const vimeoPlayButton = vimeoWrapper.querySelector('.js-vimeoPlayButton');
    const vimeoPlayerFrame = vimeoWrapper.querySelector('.js-vimeoPlayerFrame');
    let vimeoPlayer = new Player(vimeoPlayerFrame);
    if (vimeoPlayButton || vimeoPlayerFrame) {
      vimeoPlayButton.addEventListener('click', (e) => {
        e.preventDefault();
        vimeoWrapper.classList.add('is-playing');
        vimeoPlayer.play();
      });
    }
  });
  }
}

export {
  init,
};